// extracted by mini-css-extract-plugin
export var breadcrumbWrapper = "articleTemplate-module--breadcrumbWrapper--5662e";
export var wrapper = "articleTemplate-module--wrapper--def04";